import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

// pages/body content
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById('pageContent'));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);